import {UIDeviceInfoPopup} from '../../../shared/scripts/ui_popup/UIDeviceInfoPopup.tsx'

export class UIWDeviceInfoPopup extends UIDeviceInfoPopup {
    constructor() {
        const platform = `<b>Platform: </b> ${(window.navigator as any)?.userAgentData?.platform ?? navigator?.platform}  <br/>`
        const cookieEnabled = `<b>Cookie Enabled: </b> ${navigator?.cookieEnabled}  <br/>`
        super(platform + cookieEnabled)
    }
}
